import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FiArrowLeft, FiSave, FiCheck, FiX } from 'react-icons/fi';
import api from '../../services/api';
import './RegistroPresenca.css';

const RegistroPresenca = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [reuniao, setReuniao] = useState(null);
  const [colaboradores, setColaboradores] = useState([]);
  const [presencas, setPresencas] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const fetchReuniao = useCallback(async () => {
    try {
      const response = await api.get(`/reunioes/${id}`);
      setReuniao(response.data);
    } catch (error) {
      console.error('Erro ao buscar reunião:', error);
      navigate('/reunioes');
    }
  }, [id, navigate]);

  const fetchColaboradores = useCallback(async () => {
    try {
      const response = await api.get('/colaboradores');
      setColaboradores(response.data);
      
      // Buscar presenças já registradas
      const presencasResponse = await api.get(`/reunioes/${id}/presencas`);
      const presencasExistentes = {};
      presencasResponse.data.forEach(presenca => {
        presencasExistentes[presenca.colaborador_id] = presenca.presente;
      });
      setPresencas(presencasExistentes);
    } catch (error) {
      console.error('Erro ao buscar colaboradores:', error);
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchReuniao();
    fetchColaboradores();
  }, [fetchReuniao, fetchColaboradores]);

  const handlePresencaChange = (colaboradorId, presente) => {
    setPresencas(prev => ({
      ...prev,
      [colaboradorId]: presente
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);

    try {
      const presencasData = Object.entries(presencas).map(([colaboradorId, presente]) => ({
        reuniao_id: parseInt(id),
        colaborador_id: parseInt(colaboradorId),
        presente: presente
      }));

      await api.post('/presencas/lote', { presencas: presencasData });
      navigate(`/reunioes/${id}`);
    } catch (error) {
      console.error('Erro ao registrar presenças:', error);
      alert('Erro ao registrar presenças. Tente novamente.');
    } finally {
      setSaving(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('pt-BR');
  };

  const formatTime = (timeString) => {
    return timeString.substring(0, 5);
  };

  if (loading) {
    return <div className="loading">Carregando...</div>;
  }

  return (
    <div className="registro-presenca-page">
      <div className="page-header">
        <button
          onClick={() => navigate(`/reunioes/${id}`)}
          className="btn btn-secondary"
        >
          <FiArrowLeft size={20} />
          Voltar
        </button>
        <h1>Registrar Presença</h1>
      </div>

      {reuniao && (
        <div className="reuniao-info">
          <h2>{reuniao.titulo}</h2>
          <div className="info-details">
            <span>{formatDate(reuniao.data)}</span>
            <span>{formatTime(reuniao.hora_inicio)} - {formatTime(reuniao.hora_fim)}</span>
            {reuniao.local && <span>{reuniao.local}</span>}
          </div>
        </div>
      )}

      <form onSubmit={handleSubmit} className="presenca-form">
        <div className="colaboradores-list">
          <h3>Colaboradores</h3>
          {colaboradores.map(colaborador => (
            <div key={colaborador.id} className="colaborador-item">
              <div className="colaborador-info">
                <h4>{colaborador.nome}</h4>
                <p>{colaborador.departamento} - {colaborador.cargo}</p>
              </div>
              <div className="presenca-controls">
                <button
                  type="button"
                  className={`btn-presenca ${presencas[colaborador.id] === true ? 'presente' : ''}`}
                  onClick={() => handlePresencaChange(colaborador.id, true)}
                >
                  <FiCheck size={16} />
                  Presente
                </button>
                <button
                  type="button"
                  className={`btn-presenca ${presencas[colaborador.id] === false ? 'ausente' : ''}`}
                  onClick={() => handlePresencaChange(colaborador.id, false)}
                >
                  <FiX size={16} />
                  Ausente
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate(`/reunioes/${id}`)}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={saving}
            className="btn btn-primary"
          >
            <FiSave size={20} />
            {saving ? 'Salvando...' : 'Salvar Presenças'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default RegistroPresenca; 